import { Input } from '@estac1/ui';
import { FILTERS } from './utils.js';

interface ClientFiltersProps {
  search: string;
  statusFilter: string;
  onSearch: (value: string) => void;
  onStatusFilter: (value: (typeof FILTERS)[number]['id']) => void;
}

export const ClientFilters = ({
  search,
  statusFilter,
  onSearch,
  onStatusFilter,
}: ClientFiltersProps) => (
  <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
    <Input
      placeholder="Buscar por nome, email ou estacionamento"
      value={search}
      onChange={(e) => onSearch(e.target.value)}
      className="sm:max-w-md"
    />
    <div className="flex flex-wrap gap-1 rounded border border-border bg-surface p-1">
      {FILTERS.map((f) => {
        const active = statusFilter === f.id;
        return (
          <button
            key={f.id}
            type="button"
            onClick={() => onStatusFilter(f.id)}
            className={
              active
                ? 'rounded bg-fg px-3 py-1 text-xs font-medium text-bg'
                : 'rounded px-3 py-1 text-xs text-muted-fg hover:bg-muted/60'
            }
          >
            {f.label}
          </button>
        );
      })}
    </div>
  </div>
);
